export const packageRouter = [
  {
    path: "/packages",
    name: "package",
    component: () => import("../pages/package/main-package/PackageList.vue"),
    meta: {
      text: "$vuetify.layout.navigationSidebar.mainPackage",
      parent: {
        name: "$vuetify.layout.navigationSidebar.package",
        disabled: false,
      },
    },
  },
  {
    path: "/packages/add-on",
    name: "package-add-on",
    component: () => import("../pages/package/add-on-package/AddOnList.vue"),
    meta: {
      text: "$vuetify.layout.navigationSidebar.addOn",
      parent: {
        name: "$vuetify.layout.navigationSidebar.package",
        disabled: false,
        path: "/packages",
        exact: true,
      },
    },
  },
  {
    path: "/packages/add-on-birthday",
    name: "package-add-on-birthday",
    component: () => import("../pages/package/add-on-birthday-package/AddOnBirthdayList.vue"),
    meta: {
      text: "$vuetify.layout.navigationSidebar.birthdayAddOn",
      parent: {
        name: "$vuetify.layout.navigationSidebar.package",
        disabled: false,
        path: "/packages",
        exact: true,
      },
    },
  },
  {
    path: "/packages/add-on-birthday/create-premium-addon",
    name: "create-premium-addon",
    component: () => import("../pages/package/add-on-birthday-package/CreateAddonPremium.vue"),
    meta: {
      text: "$vuetify.layout.navigationSidebar.createAddonPremium",
      parent: {
        name: "$vuetify.layout.navigationSidebar.birthdayAddOn",
        disabled: false,
        path: "/packages/add-on-birthday",
        exact: true,
      },
    },
  },
  {
    path: "/packages/add-on-birthday/create-birthday-addon",
    name: "create-birthday-addon",
    component: () => import("../pages/package/add-on-birthday-package/CreateAddonBirthday.vue"),
    meta: {
      text: "$vuetify.layout.navigationSidebar.createAddonBirthday",
      parent: {
        name: "$vuetify.layout.navigationSidebar.birthdayAddOn",
        disabled: false,
        path: "/packages/add-on-birthday",
        exact: true,
      },
    },
  },
  {
    path: "/packages/add-on-birthday/edit-premium-addon/:id",
    name: "edit-premium-addon",
    component: () => import("../pages/package/add-on-birthday-package/EditAddonPremium.vue"),
    meta: {
      text: "$vuetify.package.addon.editAddonPremium",
      parent: {
        name: "$vuetify.layout.navigationSidebar.birthdayAddOn",
        disabled: false,
        path: "/packages/add-on-birthday",
        exact: true,
      },
    },
  },
  {
    path: "/packages/add-on-birthday/edit-birthday-addon/:id",
    name: "edit-birthday-addon",
    component: () => import("../pages/package/add-on-birthday-package/EditAddonBirthday.vue"),
    meta: {
      text: "$vuetify.package.addon.editAddonBirthday",
      parent: {
        name: "$vuetify.layout.navigationSidebar.birthdayAddOn",
        disabled: false,
        path: "/packages/add-on-birthday",
        exact: true,
      },
    },
  },
  {
    path: "/packages/create/:id?",
    name: "create-package",
    component: () => import("../pages/package/main-package/create-package/CreatePackage.vue"),
    meta: {
      text: "$vuetify.layout.navigationSidebar.createPackage",
      parent: {
        name: "$vuetify.layout.navigationSidebar.package",
        disabled: false,
        path: "/packages",
        exact: true,
      },
    },
  },
  // {
  //   path: "/packages/create/:id/menu",
  //   name: "create-package-menu",
  //   component: () => import("../pages/package/CreateMenu.vue"),
  //   meta: {
  //     text: "Create Menu List",
  //     parent: {
  //       name: "Package",
  //       disabled: false,
  //       path: "/packages/create/:id",
  //       exact: true,
  //       meta: {
  //         text: "Create Package",
  //         parent: {
  //           name: "Package",
  //           disabled: false,
  //           path: "/packages",
  //           exact: true,
  //         },
  //       },
  //     },
  //   },
  // },
  {
    path: "/packages/edit/:id",
    name: "edit-package",
    component: () => import("../pages/package/main-package/edit-package/EditPackage.vue"),
    meta: {
      text: "$vuetify.layout.navigationSidebar.editPackage",
      parent: {
        name: "$vuetify.layout.navigationSidebar.package",
        disabled: false,
        path: "/packages",
        exact: true,
      },
    },
  },
];
